import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import Usuario from '../usuario/usuario';
import IdeiaNegocio from '../ideiaNegocio/ideiaNegocio';
import Dicionario from '../dicionario/dicionario';
import Parceiro from '../parceiro/parceiro';
import Startup from '../startup/startup';
import Evento from '../evento/evento';
import Mentor from '../mentor/mentor';
import TrilhaConhecimento from '../trilhaConhecimento/trilhaConhecimento';
import AdmIdeiaNegocio from '../ideiaNegocio/admIdeiaNegocio';
import AdmTrilhaConhecimento from '../trilhaConhecimento/admTrilhaConhecimento';
import IncubacaoSelecao from '../incubacaoSelecao/incubacaoSelecao';
import AdmIncubacaoSelecao from '../incubacaoSelecao/admIncubacaoSelecao';
import Video from '../video/video';
import AdmIncubacao from '../incubacao/admIncubacao';
import Incubacao from '../incubacao/incubacao';
import IncubacaoPlanejamento from '../incubacaoPlanejamento/incubacaoPlanejamento';
import IncubacaoMeta from '../incubacaoMeta/incubacaoMeta';
import IncubacaoConsultoria from '../incubacaoConsultoria/incubacaoConsultoria';
import IncubacaoMaturidadeAno1 from '../incubacaoMaturidadeAno1/incubacaoMaturidadeAno1';
import IncubacaoMaturidadeAno2 from '../incubacaoMaturidadeAno2/incubacaoMaturidadeAno2';
import IncubacaoMaturidadeAno3 from '../incubacaoMaturidadeAno3/incubacaoMaturidadeAno3';
import Oportunidade from '../oportunidade/oportunidade';
import IncubacaoAvaliacao from '../incubacaoAvaliacao/incubacaoAvaliacao';
import AdmAvaliacao from '../incubacaoAvaliacao/admAvaliacao';

export default props => (
	<div id='id-content-wrapper' 
		className='content-wrapper' 
		style={{
			height: '100vh'
		}}>
		<Switch>
			<Route exact path='/' component={IdeiaNegocio} />
			{/* <Route path='/usuario' component={Usuario} /> */}
			<Route path='/ideiaNegocio' component={IdeiaNegocio} />
			<Route path='/dicionario' component={Dicionario} />
			<Route path='/parceiro' component={Parceiro} />
			<Route path='/startup' component={Startup} />
			<Route path='/evento' component={Evento} />
			<Route path='/mentor' component={Mentor} />
			<Route path='/trilhaConhecimento' component={TrilhaConhecimento} />
			{props.administrador &&
			<Route path='/admIdeiaNegocio' component={AdmIdeiaNegocio} />}
			{props.administrador &&
			<Route path='/admTrilhaConhecimento' component={AdmTrilhaConhecimento} />}
			{props.administrador &&
			<Route path='/admVideo' component={Video} />}
			<Route path='/incubacaoSelecao' component={IncubacaoSelecao} />
			{props.administrador &&
			<Route path='/admIncubacaoSelecao' component={AdmIncubacaoSelecao} />}
			{props.administrador &&
			<Route path='/admIncubacao' component={AdmIncubacao} />}
			<Route path='/incubacao' component={Incubacao} />
			<Route path='/oportunidade' component={Oportunidade} />
			<Route path='/incubacaoAvaliacao' component={IncubacaoAvaliacao} />
			{props.administrador &&
			<Route path='/admAvaliacao' component={AdmAvaliacao} />}
			{/* <Route path='/incubacaoPlanejamento' component={IncubacaoPlanejamento} />
			<Route path='/incubacaoMeta' component={IncubacaoMeta} />
			<Route path='/incubacaoConsultoria' component={IncubacaoConsultoria} />
			<Route path='/incubacaoMaturidadeAno1' component={IncubacaoMaturidadeAno1} /> */}
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
